import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { supabase } from '../services/supabase';
import { logger } from '../services/logger';
import { isPreviewMode } from '../services/supabase';
import { AppNav } from '../components/AppNav';

export function ProtectedLayout() {
  const navigate = useNavigate();

  // Check authentication
  useEffect(() => {
    async function checkAuth() {
      if (isPreviewMode()) return;

      try {
        const { data: { session } } = await supabase.auth.getSession();
        if (!session) {
          navigate('/login');
        }
      } catch (error) {
        logger.error('Auth check error:', error);
        navigate('/login');
      }
    }

    checkAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-paper flex flex-col">
      {isPreviewMode() && (
        <div className="bg-gold-500 text-ink-950 px-4 py-2 text-center text-sm font-medium shadow-sm">
          Preview Mode - Some features are simulated
        </div>
      )}

      <AppNav />

      <main className="flex-1 bg-gradient-to-br from-paper to-gray-50">
        <Outlet />
      </main>
    </div>
  );
}